(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9652],{

/***/ 44133:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 86628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Ot; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
function e(){return(e=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const n=(/* unused pure expression or super */ null && (["children","options"])),r=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((t,e)=>(t[e.toLowerCase()]=e,t),{for:"htmlFor"}),o={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},c=["style","script"],a=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,u=/mailto:/i,i=/\n{2,}$/,l=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,s=/^ *> ?/gm,_=/^ {2,}\n/,f=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,d=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,p=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,g=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,m=/^(?:\n *)*\n/,y=/\r\n?/g,h=/^\[\^([^\]]+)](:.*)\n/,k=/^\[\^([^\]]+)]/,x=/\f/g,b=/^\s*?\[(x|\s)\]/,v=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,S=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,$=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,w=/&([a-z]+);/g,z=/^<!--[\s\S]*?(?:-->)/,E=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,A=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,R=/^\{.*\}$/,I=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,M=/^<([^ >]+@[^ >]+)>/,O=/^<([^ >]+:\/[^ >]+)>/,B=/ *\n+$/,L=/(?:^|\n)( *)$/,T=/-([a-z])?/gi,j=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,C=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,D=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,N=/^\[([^\]]*)\] ?\[([^\]]*)\]/,Z=/(\[|\])/g,F=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,P=/\t/g,G=/^ *\| */,H=/(^ *\||\| *$)/g,q=/ *$/,U=/^ *:-+: *$/,V=/^ *:-+ *$/,W=/^ *-+: *$/,Q=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,X=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,J=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,K=/^\\([^0-9A-Za-z\s])/,Y=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,tt=/^\n+/,et=/^([ \t]*)/,nt=/\\([^0-9A-Z\s])/gi,rt=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),ot=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)","gm"),ct=new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),at="(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",ut=new RegExp("^\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),it=new RegExp("^!\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),lt=[l,p,d,v,S,z,ot,ct,j],st=[...lt,/^[^\n]+(?:  \n|\n{2,})/,$,A];function _t(t){return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function ft(t){return W.test(t)?"right":U.test(t)?"center":V.test(t)?"left":null}function dt(t,e,n){const r=n.t;n.t=!0;const o=e(t.trim(),n);n.t=r;let c=[[]];return o.forEach(function(t,e){"tableSeparator"===t.type?0!==e&&e!==o.length-1&&c.push([]):("text"!==t.type||null!=o[e+1]&&"tableSeparator"!==o[e+1].type||(t.content=t.content.replace(q,"")),c[c.length-1].push(t))}),c}function pt(t,e,n){n.o=!0;const r=dt(t[1],e,n),o=t[2].replace(H,"").split("|").map(ft),c=function(t,e,n){return t.trim().split("\n").map(function(t){return dt(t,e,n)})}(t[3],e,n);return n.o=!1,{align:o,cells:c,header:r,type:"table"}}function gt(t,e){return null==t.align[e]?{}:{textAlign:t.align[e]}}function mt(t){return function(e,n){return n.o?t.exec(e):null}}function yt(t){return function(e,n){return n.o||n.u?t.exec(e):null}}function ht(t){return function(e,n){return n.o||n.u?null:t.exec(e)}}function kt(t){return function(e){return t.exec(e)}}function xt(t,e,n){if(e.o||e.u)return null;if(n&&!n.endsWith("\n"))return null;let r="";t.split("\n").every(t=>!lt.some(e=>e.test(t))&&(r+=t+"\n",t.trim()));const o=r.trimEnd();return""==o?null:[r,o]}function bt(t){try{if(decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data):/i))return null}catch(t){return null}return t}function vt(t){return t.replace(nt,"$1")}function St(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!0,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function $t(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!1,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function wt(t,e,n){return n.o=!1,t(e+"\n\n",n)}const zt=(t,e,n)=>({content:St(e,t[1],n)});function Et(){return{}}function At(){return null}function Rt(...t){return t.filter(Boolean).join(" ")}function It(t,e,n){let r=t;const o=e.split(".");for(;o.length&&(r=r[o[0]],void 0!==r);)o.shift();return r||n}var Mt;function Ot(n,H={}){H.overrides=H.overrides||{},H.slugify=H.slugify||_t,H.namedCodesToUnicode=H.namedCodesToUnicode?e({},o,H.namedCodesToUnicode):o;const q=H.createElement||react__WEBPACK_IMPORTED_MODULE_0__.createElement;function U(t,n,...r){const o=It(H.overrides,`${t}.props`,{});return q(function(t,e){const n=It(e,t);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:It(e,`${t}.component`,t):t}(t,H.overrides),e({},n,o,{className:Rt(null==n?void 0:n.className,o.className)||void 0}),...r)}function V(e){let n=!1;H.forceInline?n=!0:H.forceBlock||(n=!1===F.test(e));const r=dt(ft(n?e:`${e.trimEnd().replace(tt,"")}\n\n`,{o:n}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===H.wrapper)return r;const o=H.wrapper||(n?"span":"div");let c;if(r.length>1||H.forceWrapper)c=r;else{if(1===r.length)return c=r[0],"string"==typeof c?U("span",{key:"outer"},c):c;c=null}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,{key:"outer"},c)}function W(e){const n=e.match(a);return n?n.reduce(function(e,n,o){const c=n.indexOf("=");if(-1!==c){const a=function(t){return-1!==t.indexOf("-")&&null===t.match(E)&&(t=t.replace(T,function(t,e){return e.toUpperCase()})),t}(n.slice(0,c)).trim(),u=function(t){const e=t[0];return('"'===e||"'"===e)&&t.length>=2&&t[t.length-1]===e?t.slice(1,-1):t}(n.slice(c+1).trim()),i=r[a]||a,l=e[i]=function(t,e){return"style"===t?e.split(/;\s?/).reduce(function(t,e){const n=e.slice(0,e.indexOf(":"));return t[n.replace(/(-[a-z])/g,t=>t[1].toUpperCase())]=e.slice(n.length+1).trim(),t},{}):"href"===t?bt(e):(e.match(R)&&(e=e.slice(1,e.length-1)),"true"===e||"false"!==e&&e)}(a,u);"string"==typeof l&&($.test(l)||A.test(l))&&(e[i]=react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(V(l.trim()),{key:o}))}else"style"!==n&&(e[r[n]||n]=!0);return e},{}):void 0}const nt=[],at={},lt={blockQuote:{i:ht(l),l:Mt.HIGH,_:(t,e,n)=>({content:e(t[0].replace(s,""),n)}),p:(t,e,n)=>U("blockquote",{key:n.g},e(t.content,n))},breakLine:{i:kt(_),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("br",{key:n.g})},breakThematic:{i:ht(f),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("hr",{key:n.g})},codeBlock:{i:ht(p),l:Mt.MAX,_:t=>({content:t[0].replace(/^ {4}/gm,"").replace(/\n+$/,""),lang:void 0}),p:(t,e,n)=>U("pre",{key:n.g},U("code",{className:t.lang?`lang-${t.lang}`:""},t.content))},codeFenced:{i:ht(d),l:Mt.MAX,_:t=>({content:t[3],lang:t[2]||void 0,type:"codeBlock"})},codeInline:{i:yt(g),l:Mt.LOW,_:t=>({content:t[2]}),p:(t,e,n)=>U("code",{key:n.g},t.content)},footnote:{i:ht(h),l:Mt.MAX,_:t=>(nt.push({footnote:t[2],identifier:t[1]}),{}),p:At},footnoteReference:{i:mt(k),l:Mt.HIGH,_:t=>({content:t[1],target:`#${H.slugify(t[1])}`}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target)},U("sup",{key:n.g},t.content))},gfmTask:{i:mt(b),l:Mt.HIGH,_:t=>({completed:"x"===t[1].toLowerCase()}),p:(t,e,n)=>U("input",{checked:t.completed,key:n.g,readOnly:!0,type:"checkbox"})},heading:{i:ht(v),l:Mt.HIGH,_:(t,e,n)=>({content:St(e,t[2],n),id:H.slugify(t[2]),level:t[1].length}),p:(t,e,n)=>(t.tag=`h${t.level}`,U(t.tag,{id:t.id,key:n.g},e(t.content,n)))},headingSetext:{i:ht(S),l:Mt.MAX,_:(t,e,n)=>({content:St(e,t[1],n),level:"="===t[2]?1:2,type:"heading"})},htmlComment:{i:kt(z),l:Mt.HIGH,_:()=>({}),p:At},image:{i:yt(it),l:Mt.HIGH,_:t=>({alt:t[1],target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt||void 0,title:t.title||void 0,src:bt(t.target)})},link:{i:mt(ut),l:Mt.LOW,_:(t,e,n)=>({content:$t(e,t[1],n),target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target),title:t.title},e(t.content,n))},linkAngleBraceStyleDetector:{i:mt(O),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],type:"link"})},linkBareUrlDetector:{i:(t,e)=>e.m?null:mt(I)(t,e),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],title:void 0,type:"link"})},linkMailtoDetector:{i:mt(M),l:Mt.MAX,_(t){let e=t[1],n=t[1];return u.test(n)||(n="mailto:"+n),{content:[{content:e.replace("mailto:",""),type:"text"}],target:n,type:"link"}}},list:{i(t,e,n){const r=L.exec(n);return!r||!e.h&&e.o?null:ct.exec(t=r[1]+t)},l:Mt.HIGH,_(t,e,n){const r=t[2],o=r.length>1,c=o?+r:void 0,a=t[0].replace(i,"\n").match(ot);let u=!1;return{items:a.map(function(t,r){const o=rt.exec(t)[0].length,c=new RegExp("^ {1,"+o+"}","gm"),i=t.replace(c,"").replace(rt,""),l=r===a.length-1,s=-1!==i.indexOf("\n\n")||l&&u;u=s;const _=n.o,f=n.h;let d;n.h=!0,s?(n.o=!1,d=i.replace(B,"\n\n")):(n.o=!0,d=i.replace(B,""));const p=e(d,n);return n.o=_,n.h=f,p}),ordered:o,start:c}},p:(t,e,n)=>U(t.ordered?"ol":"ul",{key:n.g,start:t.start},t.items.map(function(t,r){return U("li",{key:r},e(t,n))}))},newlineCoalescer:{i:ht(m),l:Mt.LOW,_:Et,p:()=>"\n"},paragraph:{i:xt,l:Mt.LOW,_:zt,p:(t,e,n)=>U("p",{key:n.g},e(t.content,n))},ref:{i:mt(C),l:Mt.MAX,_:t=>(at[t[1]]={target:t[2],title:t[4]},{}),p:At},refImage:{i:yt(D),l:Mt.MAX,_:t=>({alt:t[1]||void 0,ref:t[2]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt,src:bt(at[t.ref].target),title:at[t.ref].title})},refLink:{i:mt(N),l:Mt.MAX,_:(t,e,n)=>({content:e(t[1],n),fallbackContent:e(t[0].replace(Z,"\\$1"),n),ref:t[2]}),p:(t,e,n)=>at[t.ref]?U("a",{key:n.g,href:bt(at[t.ref].target),title:at[t.ref].title},e(t.content,n)):U("span",{key:n.g},e(t.fallbackContent,n))},table:{i:ht(j),l:Mt.HIGH,_:pt,p:(t,e,n)=>U("table",{key:n.g},U("thead",null,U("tr",null,t.header.map(function(r,o){return U("th",{key:o,style:gt(t,o)},e(r,n))}))),U("tbody",null,t.cells.map(function(r,o){return U("tr",{key:o},r.map(function(r,o){return U("td",{key:o,style:gt(t,o)},e(r,n))}))})))},tableSeparator:{i:function(t,e){return e.t?G.exec(t):null},l:Mt.HIGH,_:function(){return{type:"tableSeparator"}},p:()=>" | "},text:{i:kt(Y),l:Mt.MIN,_:t=>({content:t[0].replace(w,(t,e)=>H.namedCodesToUnicode[e]?H.namedCodesToUnicode[e]:t)}),p:t=>t.content},textBolded:{i:yt(Q),l:Mt.MED,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("strong",{key:n.g},e(t.content,n))},textEmphasized:{i:yt(X),l:Mt.LOW,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("em",{key:n.g},e(t.content,n))},textEscaped:{i:yt(K),l:Mt.HIGH,_:t=>({content:t[1],type:"text"})},textStrikethroughed:{i:yt(J),l:Mt.LOW,_:zt,p:(t,e,n)=>U("del",{key:n.g},e(t.content,n))}};!0!==H.disableParsingRawHTML&&(lt.htmlBlock={i:kt($),l:Mt.HIGH,_(t,e,n){const[,r]=t[3].match(et),o=new RegExp(`^${r}`,"gm"),a=t[3].replace(o,""),u=(i=a,st.some(t=>t.test(i))?wt:St);var i;const l=t[1].toLowerCase(),s=-1!==c.indexOf(l);n.m=n.m||"a"===l;const _=s?t[3]:u(e,a,n);return n.m=!1,{attrs:W(t[2]),content:_,noInnerParse:s,tag:s?l:t[1]}},p:(t,n,r)=>U(t.tag,e({key:r.g},t.attrs),t.noInnerParse?t.content:n(t.content,r))},lt.htmlSelfClosing={i:kt(A),l:Mt.HIGH,_:t=>({attrs:W(t[2]||""),tag:t[1]}),p:(t,n,r)=>U(t.tag,e({},t.attrs,{key:r.g}))});const ft=function(t){let e=Object.keys(t);function n(r,o){let c=[],a="";for(;r;){let u=0;for(;u<e.length;){const i=e[u],l=t[i],s=l.i(r,o,a);if(s){const t=s[0];r=r.substring(t.length);const e=l._(s,n,o);null==e.type&&(e.type=i),c.push(e),a=t;break}u++}}return c}return e.sort(function(e,n){let r=t[e].l,o=t[n].l;return r!==o?r-o:e<n?-1:1}),function(t,e){return n(function(t){return t.replace(y,"\n").replace(x,"").replace(P,"    ")}(t),e)}}(lt),dt=(Ot=function(t){return function(e,n,r){return t[e.type].p(e,n,r)}}(lt),function t(e,n={}){if(Array.isArray(e)){const r=n.g,o=[];let c=!1;for(let r=0;r<e.length;r++){n.g=r;const a=t(e[r],n),u="string"==typeof a;u&&c?o[o.length-1]+=a:null!==a&&o.push(a),c=u}return n.g=r,o}return Ot(e,t,n)});var Ot;const Bt=V(n);return nt.length?U("div",null,Bt,U("footer",{key:"footer"},nt.map(function(t){return U("div",{id:H.slugify(t.identifier),key:t.identifier},t.identifier,dt(ft(t.footnote,{o:!0})))}))):Bt}!function(t){t[t.MAX=0]="MAX",t[t.HIGH=1]="HIGH",t[t.MED=2]="MED",t[t.LOW=3]="LOW",t[t.MIN=4]="MIN"}(Mt||(Mt={}));/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (e=>{let{children:r,options:o}=e,c=function(t,e){if(null==t)return{};var n,r,o={},c=Object.keys(t);for(r=0;r<c.length;r++)e.indexOf(n=c[r])>=0||(o[n]=t[n]);return o}(e,n);return t.cloneElement(Ot(r,o),c)});
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 38993:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-positive-care",
      function () {
        return __webpack_require__(25773);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ImageItemList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);




const ImageItem = (param)=>{
    let { header , content , image , className , step  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "mb16 mb10-md ph4 ph0-md ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: image.src,
                height: image.height,
                width: image.height,
                alt: ""
            }),
            Number.isInteger(step) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "darkGreen ttu font-im",
                children: i18n.t("Step {{number}}", {
                    number: step
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-cm fs28 fs20-md lh12 mt2 mb3 mb1-md gray800 maxw18-md",
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "lh14 fs16-md font-ir gray600 maxw25 maxw16-md",
                children: content
            })
        ]
    });
};
const ImageItemList = (param)=>/*#__PURE__*/ {
    let { items , rows =1 , itemClassName ="" , showSteps =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "df jcsb fdc-md ".concat(rows > 1 && "fw"),
        children: items.map((item, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageItem, {
                // @ts-expect-error TS2322: Type 'number | false' is not assignable to type 'number | undefined'.
                step: showSteps && key + 1,
                ...item,
                className: "".concat(itemClassName, " ").concat(rows === 2 && "w50p w100p-md")
            }, key))
    });
};


/***/ }),

/***/ 46452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ IllustratedTextDecoration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52299);



const IllustratedTextDecoration = (param)=>/*#__PURE__*/ {
    let { type , style , className , width ="100%" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__/* .V5Image */ .dZ, {
        style: {
            bottom: type === "circle" ? 1 : -14,
            ...style
        },
        src: "home/word-".concat(type),
        imgExt: "webp",
        className: "pos-a-center right0 left0 ma maxw-none zIndex-1 ".concat(className),
        width: width,
        ...props,
        alt: ""
    });
};


/***/ }),

/***/ 46102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wE": function() { return /* binding */ useGetSoonestTimeByLocationsAndSpecialtyIds; },
/* harmony export */   "xz": function() { return /* binding */ getSortedSoonestLocationWithAvailableSlotBySpecialty; },
/* harmony export */   "zn": function() { return /* binding */ useGetSoonestInPracticeBySpecialtyId; }
/* harmony export */ });
/* unused harmony export getSoonestSlotFromApptSlotBlock */
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36330);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95832);
/* harmony import */ var _services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72714);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34557);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40367);
/* harmony import */ var _utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39815);
/* harmony import */ var _useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15343);











const getSoonestSlotFromApptSlotBlock = (slotTimes)=>{
    var _slotTimes_, _slotTimes__;
    return slotTimes === null || slotTimes === void 0 ? void 0 : (_slotTimes_ = slotTimes[0]) === null || _slotTimes_ === void 0 ? void 0 : (_slotTimes__ = _slotTimes_[0]) === null || _slotTimes__ === void 0 ? void 0 : _slotTimes__.time;
};
const useGetSoonestInPracticeBySpecialtyId = (param)=>{
    let { specialtyId , practiceId =_constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON , daysCount =7  } = param;
    const { pageLoaded , practices , locations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const [slot, setSlot] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        if (enableCache) {
            (0,_utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__/* .fetchCachedSlotAround */ .o)({
                locations,
                specialtyId
            }).then(setSlot);
        } else {
            var _locations_filter_;
            // @ts-expect-error TS2532: Object is possibly 'undefined'.
            const virtualSpecialtyIds = practices.flatMap((p)=>p.specialties.vals()).filter((s)=>s.isVirtual).map((s)=>s.id).distinct();
            const isVirtual = virtualSpecialtyIds.includes(specialtyId);
            // if virtual care, ignore closest location
            const closestLocationPracticeId = !isVirtual && ((_locations_filter_ = locations.filter((l)=>l.specialtyIds.includes(specialtyId))[0]) === null || _locations_filter_ === void 0 ? void 0 : _locations_filter_.practiceId);
            const finalPracticeId = practiceId || closestLocationPracticeId || _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON;
            const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
            // @ts-expect-error TS2532, TS2684, TS2532: Object is possibly 'undefined'.,  The 'this' context of type 'RootStatePractice[] | undefined' is not assignable to method's 'this' of type 'RootStatePractice[]'.,  Object is possibly 'undefined'.
            const specialty = practices.findById(finalPracticeId).specialties[specialtyId] || {};
            const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = specialty;
            const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
            const to = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day");
            (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                practiceId: finalPracticeId,
                from,
                to,
                duration,
                specialtyId,
                timezone: _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A
            }).then((slots)=>{
                var _slots_;
                setSlot((slots === null || slots === void 0 ? void 0 : (_slots_ = slots[0]) === null || _slots_ === void 0 ? void 0 : _slots_[0]) || {});
            });
        }
    }, [
        pageLoaded,
        enableCache
    ]);
    return slot || null;
};
const useGetSoonestTimeByLocationsAndSpecialtyIds = (param)=>{
    let { locations , specialtyIds , daysCount =21 , specialtyCount =1 , locationCount =3  } = param;
    const { pageLoaded , locations: allLocations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return {
            ...config
        };
    });
    const selectedRegion = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)(src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__/* .selectSelectedRegion */ .dz);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [slotLocationWithTime, setSlotLocationWithTime] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
        (locations || allLocations.slice(0, locationCount)).map((l)=>{
            const sortedSpecialties = l.specialties.vals().sortBy("sortIndex").slice(0, specialtyCount);
            return (specialtyIds || sortedSpecialties.map((s)=>s.id) // if specialIds param is null, try with first specialtyId
            ).map((sId)=>{
                const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = l.specialties[sId] || {};
                const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
                return (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                    practiceId: l.practiceId,
                    locationId: l.id,
                    from,
                    to: +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day"),
                    duration,
                    specialtyId: sId,
                    timezone: l.timezone || _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A,
                    enableCache
                }).then((slotTimes)=>({
                        lId: l.id,
                        sId,
                        slotTime: getSoonestSlotFromApptSlotBlock(slotTimes)
                    }));
            }).sequence();
        }).sequence().then((locationsAndSlot)=>{
            setSlotLocationWithTime(locationsAndSlot.flat().groupBy("lId").mapValues((slots)=>slots.groupBy("sId").mapValues((slots)=>slots[0].slotTime)));
        });
    }, [
        pageLoaded,
        router.asPath,
        selectedRegion,
        enableCache
    ]);
    return slotLocationWithTime;
};
/* get first location with soonest specialty in location list
eg (assuming sf's urgentcare slot is sooner):
({locations: [berkeley, sf],specialtyId: UrgentCareId}) => {locationId: [sfLocationId]: time: 1666666} */ const getSortedSoonestLocationWithAvailableSlotBySpecialty = (param)=>{
    let { locationsWithSlots , specialtyId  } = param;
    if (locationsWithSlots.isOEmpty()) {
        // @ts-expect-error TS2322: Type 'null' is not assignable to type 'string'.
        return {
            locationId: null
        };
    }
    return locationsWithSlots.toArray()// @ts-expect-error TS2571: Object is of type 'unknown'.
    .sortBy((l)=>l[1][specialtyId])// @ts-expect-error TS2571: Object is of type 'unknown'.
    .map((l)=>({
            locationId: l[0],
            time: l[1][specialtyId]
        }))[0];
};


/***/ }),

/***/ 25773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ covid_positive_care; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1989);
// EXTERNAL MODULE: ./src/components/_common/ImageItemList.tsx
var ImageItemList = __webpack_require__(36578);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/v5/IllustratedTextDecoration.tsx
var IllustratedTextDecoration = __webpack_require__(46452);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/CovidPositiveCare/About.tsx







const About = (param)=>{
    let { nextApptSlot , bookingUrl , bookingBtnHandler  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const imageHeight = isMobile ? 100 : 170;
    const itemList = [
        {
            header: i18n.t("You've tested positive.\nNow what?"),
            content: i18n.t("You might have to isolate, but you’re never alone. Carbon Health is here to provide targeted care and answer all of your COVID related questions."),
            image: {
                src: "illustrations/virus",
                height: imageHeight
            }
        },
        {
            header: i18n.t("Chat with our\nfriendly providers"),
            content: i18n.t("There is no cost or insurance co-pay needed to enroll and unlimited virtual visits are available until you are fully recovered."),
            image: {
                src: "home/illustrated-list/02",
                height: imageHeight
            }
        },
        {
            header: i18n.t("Continuous care\nafter your call"),
            content: i18n.t("With symptom management, continuous monitoring, and mental health screenings we’ll help you manage your health and ensure your life gets back on track."),
            image: {
                src: "reason/virtualCare/continuous",
                height: imageHeight
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "ma w100p maxw80 ph10 ph4-sm pt20 pb30 pv14-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "tal mb10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "zIndex2 pos-r",
                                children: [
                                    "Personalized virtual",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "care",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "darkerGreen pos-r zIndex1",
                                children: [
                                    "on demand",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                        type: "circle",
                                        width: "130%",
                                        style: {
                                            top: 3
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItemList/* ImageItemList */.T, {
                    rows: 1,
                    items: itemList
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df aic fdc-sm aifs-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            href: bookingUrl,
                            onClick: bookingBtnHandler,
                            className: "mr5",
                            children: i18n.t("Talk to a Virtual Provider")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df fdc ml6-sm mt3-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "green font-csb mb1 fs18 fs14-sm font-ib-sm",
                                    children: nextApptSlot
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-im gray400 fs14",
                                    children: i18n.t("$0 to enroll")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CovidPositiveCare_About = (About);

// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(48489);
// EXTERNAL MODULE: ./src/useV5ImgSrc.tsx
var useV5ImgSrc = __webpack_require__(52299);
;// CONCATENATED MODULE: ./src/components/v5/CovidPositiveCare/QuestionAnswers.tsx





const QuestionAnswers = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const answers = [
        i18n.t("Helpful"),
        i18n.t("Reassuring"),
        i18n.t("Smooth"),
        i18n.t("Attentive"),
        i18n.t("Convenient"),
        i18n.t("Efficient"),
        i18n.t("Excellent"),
        i18n.t("Simple")
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df fdc-sm pos-r",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx3 df fdc jcc aife aifs-sm pl8 pr20 pv15 pb6-xs ph4-xs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "df fdc maxw42",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ttu font-ir gray400 font-im fs13 mb8 mb6-xs font-mb-f-xs fs12-xs",
                                children: i18n.t("We asked")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "fs48 lh12 fs40-lg fs38-md fs30-sm fs24-xs maxw32-lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                                    children: [
                                        "What's one word you would use to",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "purple",
                                            children: "describe your experience in the care program?"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fx2 df fdc bg-lighterPurple pl12 pl8-md ph4-xs pt12 pb10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ttu font-ir gray400 font-im fs13 mb8 mb6-xs font-mb-f-xs fs12-xs",
                            children: i18n.t("You Answered")
                        }),
                        answers.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "darkPurple fs60 fs48-lg fs40-md fs38-sm font-csb mb4 mb3-xs",
                                children: a
                            }, a))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                    className: "pos-a maxw6 maxw5-md dn-sm",
                    style: {
                        left: "57%",
                        top: 90
                    },
                    src: (0,useV5ImgSrc/* useV5ImgSrc */.eH)("illustrated-arrow-purple")
                })
            ]
        })
    });
};
/* harmony default export */ var CovidPositiveCare_QuestionAnswers = (QuestionAnswers);

// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/CovidPositiveCare/Resources.module.scss
var Resources_module = __webpack_require__(53423);
var Resources_module_default = /*#__PURE__*/__webpack_require__.n(Resources_module);
;// CONCATENATED MODULE: ./src/components/v5/CovidPositiveCare/Resources.tsx







const Resources = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const style = {
        backgroundImage: "url(".concat((0,useV5ImgSrc/* useV5ImgSrc */.eH)("covid-positive-care-resources"), ")")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ph10 ".concat((Resources_module_default()).outer),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw90 ma df fdc aic-sm ".concat((Resources_module_default()).inner),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Resources_module_default()).header,
                    children: i18n.t("RESOURCES")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Resources_module_default()).title,
                    children: i18n.t("You may be isolated, but you're not alone.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "maxw32 ".concat((Resources_module_default()).text),
                    children: i18n.t("We've curated the best resources on the web to help you navigate life with and after testing positive for COVID-19.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                    className: "event-SKi37d",
                    href: _constants/* v5Pages.covidPositiveCare */.Td.covidPositiveCare,
                    children: i18n.t("Learn more")
                })
            ]
        })
    });
};
/* harmony default export */ var CovidPositiveCare_Resources = (/*#__PURE__*/react.memo(Resources));

// EXTERNAL MODULE: ./src/constants/apptReasons.ts
var apptReasons = __webpack_require__(4063);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/hooks/useFaqIndex.tsx + 2 modules
var useFaqIndex = __webpack_require__(47924);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/us-state-codes/states.json
var states = __webpack_require__(24636);
// EXTERNAL MODULE: ./src/components/v5/CoverageMap.module.scss
var CoverageMap_module = __webpack_require__(99274);
var CoverageMap_module_default = /*#__PURE__*/__webpack_require__.n(CoverageMap_module);
;// CONCATENATED MODULE: ./src/components/v5/CoverageMap.tsx







const CoverageMap = (param)=>{
    let { coveredStates  } = param;
    const notStates = [
        "PR",
        "DC"
    ];
    const count = coveredStates.length;
    const allStates = states.getKeys().filter((code)=>!notStates.includes(code)).map((code)=>({
            code,
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ AL: string; AK: string; AZ: string; AR: string; CA: string; CO: string; CT: string; DE: string; DC: string; FL: string; GA: string; HI: string; ID: string; IL: string; IN: string; IA: string; KS: string; KY: string; ... 33 more ...; WY: string; }'.
            name: states[code],
            isCovered: coveredStates.includes(code)
        }));
    const renderedStates = allStates.map((param)=>/*#__PURE__*/ {
        let { code , name , isCovered  } = param;
        return (0,jsx_runtime.jsxs)("div", {
            className: "".concat((CoverageMap_module_default()).state, " ").concat(isCovered ? "" : (CoverageMap_module_default())["not-covered"]),
            style: {
                "--gridArea": code,
                backgroundColor: isCovered ? palette.darkerMint : palette.gray100,
                color: isCovered ? "#fff" : palette.gray200
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CoverageMap_module_default())["state-code"],
                    children: code
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (CoverageMap_module_default())["state-name"],
                    children: name
                })
            ]
        }, code);
    });
    const formattedCoveredStates = allStates.filter((s)=>s.isCovered);
    const coveredStateNames = formattedCoveredStates.map((st)=>st.name).append("Washington D.C.");
    const half = Math.floor(count / 2);
    const listColumns = [
        coveredStateNames.slice(0, half),
        coveredStateNames.slice(half, count)
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "df fdc aic bg-gray50 pv30 pv10-md pv8-sm ".concat((CoverageMap_module_default()).outer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 maxw30-md maxw22-sm df-f-md fdc-f-md aifs-md pb8-md ".concat((CoverageMap_module_default()).inner),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "tac tal-md fs48 fs36-md fs32-sm fs24-xs mb10 mb4-lg pl18-md pl4-sm ".concat((CoverageMap_module_default()).header),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        count: count,
                        children: [
                            "Currently offered in",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "darkerGreen pos-r wsnw",
                                children: [
                                    {
                                        count
                                    },
                                    " states",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                        type: "underline"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "df jcc aic ph10 ph0-sm pt10 pt4-sm ".concat((CoverageMap_module_default()).list),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "df",
                        children: listColumns.map((list, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "df fdc ml8 ml6-sm",
                                children: list.map((state)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "df aic fs20 fs18-lg fs14-xs mb6 mb4-lg font-ir-xs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "bg-green br50 mr2",
                                                style: {
                                                    height: 4,
                                                    width: 4
                                                }
                                            }),
                                            state
                                        ]
                                    }, "list-".concat(state)))
                            }, "list-".concat(i)))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dn-md ".concat((CoverageMap_module_default()).map),
                    children: renderedStates
                })
            ]
        })
    });
};
/* harmony default export */ var v5_CoverageMap = (CoverageMap);

// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
;// CONCATENATED MODULE: ./src/components/v5/CovidPositiveCare/Features.tsx









const Features = (param)=>{
    let { nextApptSlot , bookingUrl , bookingBtnHandler  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const bgImageSrc = (0,useV5ImgSrc/* useV5ImgSrc */.eH)("woman-with-coffee-xl");
    const data = [
        {
            icon: "virtual-phone",
            title: i18n.t("Unlimited virtual visits on your schedule"),
            body: i18n.t("Carbon Health clinicians administer care and provide COVID-19 clearance from the comfort of your home. You can rest easy knowing our COVID medical experts will be with you until you're well.")
        },
        {
            icon: "medical-record",
            title: i18n.t("Customized care plans"),
            body: i18n.t("Whether you’re asymptomatic or navigating a more complex situation, providers will customize a plan that makes sense for you.")
        },
        {
            icon: "symptom-checker-phone2",
            title: i18n.t("Care on demand"),
            body: i18n.t("Receive customized symptom tracking and daily monitoring via our clinician teams. Depending on symptoms, we will provide over-the-counter or prescription therapies as well as guidance on symptom management.")
        },
        {
            icon: "vitals",
            title: i18n.t("Access to medical COVID experts"),
            body: i18n.t("We can help triage any short or long-term complications that may arise and, in some cases, will provide pulse oximeters for self-monitoring at no extra cost.")
        },
        {
            icon: "mental-health",
            title: i18n.t("Mental health screenings & referrals"),
            body: i18n.t("Not all COVID symptoms are physical; A positive COVID-19 test also affects your mental health. We will screen you for mental health symptoms and refer you to the proper providers if desired.")
        },
        {
            icon: "virtual-care-screen",
            title: i18n.t("Full health support"),
            body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Not only will you have full access to our team of providers, but you will also have access to digital therapeutics like Big Health & Sleepio as well as our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* Alink */.Jt, {
                        href: "/get-care/covid-treatment",
                        className: "tdu",
                        children: "resource-rich education hub"
                    }),
                    "."
                ]
            })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pv30 pb20-md pt10-md ph10 ph4-sm bg-darkerGreen pos-r",
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pos-a h100p w100p dn-md bgcov top0 right0",
                    style: {
                        backgroundImage: "url(".concat(bgImageSrc, ")"),
                        backgroundPosition: "75% 0%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h100p w100p",
                        style: {
                            background: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "maxw80 ma zIndex2 pos-r pt40 pt30-xl pt10-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "gray50 maxw35 mb48 mb40-xl mb30-lg mb8-md pr0-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                            children: [
                                "Every COVID-19 experience is unique. Our team of expert clinicians works to create a",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lightGreen",
                                    children: "customized care plan that makes sense for each patient's unique health needs."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "lightGreen font-mr fs13 fs12-sm mt20 mt8-md mb10-md",
                        children: i18n.t("With COVID Positive Care you get:")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt8 dg gg6 maxw72 af",
                        style: {
                            "--w": "305px"
                        },
                        children: data.map((d)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "bg-white br8 p10 pt14 p8-md p6-xs df fdc aifs tal maxw24 minw0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cIcon-".concat(d.icon, " fs56 lightGreen fs46-md")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt6 mt2-sm fs24 font-csb lh14 darkerGreen minh16 minh0-sm",
                                        children: d.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt4 mt2-sm font-ir-sm fs18",
                                        children: d.body
                                    })
                                ]
                            }, d.icon))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt14 dgc aic gg4 jcs gtcn-sm mt16-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                fontSize: 1,
                                bg: palette.darkGreen,
                                hoverBg: palette.green,
                                href: bookingUrl,
                                onClick: bookingBtnHandler,
                                children: i18n.t("Talk to a Virtual Provider")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gray50 tal",
                                children: [
                                    nextApptSlot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fs18 fs16-sm font-csb",
                                        children: nextApptSlot
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt2 fs14 fs12-sm font-ir",
                                        children: i18n.t("$0 to enroll")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CovidPositiveCare_Features = (Features);

;// CONCATENATED MODULE: ./src/components/v5/CovidPositiveCare/Hero.tsx





const Hero = (param)=>{
    let { bookingUrl , bookingBtnHandler , nextApptSlot  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const gradient = {
        background: "linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
        bgImage: "/covid-positive-enrollment",
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pos-r pt40 pt30-xs pb40 pb0-sm",
            style: gradient,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pv20 pb8-sm ma w100p maxw80 ph10 ph4-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fs48 fs38-md fs32-xs white font-csb lh12 mt20 maxw32 maxw28-md maxw16-xs",
                        children: i18n.t("I tested positive for COVID-19. Now what?")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "m0 mb14 mb0-sm lh12 white font-cm fs22 fs18-md fs16-sm maxw30 maxw24-md maxw22-sm maxw16-xs",
                        children: i18n.t("Get relief, comfort, and expert COVID-19 care from the comfort of your home today.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt6 dgc aic gg4 jcs gtcn-sm mt16-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                fontSize: 1,
                                bg: palette.gray800,
                                href: bookingUrl,
                                onClick: bookingBtnHandler,
                                children: i18n.t("Talk to a Virtual Provider")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gray50",
                                children: [
                                    nextApptSlot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fs18 fs16-sm font-csb font-ib-sm",
                                        children: nextApptSlot
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt2 fs14 fs12-sm font-ir",
                                        children: i18n.t("$0 to enroll")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "df aic pos-a gray50 fs12 dn-sm",
                        style: {
                            bottom: 20
                        },
                        href: "#how",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-arrow-down-thick mr2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-ib",
                                children: i18n.t("Learn More")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CovidPositiveCare_Hero = (Hero);

// EXTERNAL MODULE: ./src/components/v5/Faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(73349);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
// EXTERNAL MODULE: ./src/hooks/useGetSoonestTime.ts
var useGetSoonestTime = __webpack_require__(46102);
// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
;// CONCATENATED MODULE: ./src/pages/covid-positive-care.tsx




















const CovidPositiveEnrollment = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const maybeSlot = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
        specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE
    });
    const nextApptSlot = (0,Carbon/* todayTomorrow4 */.xf)(i18n.lang, maybeSlot === null || maybeSlot === void 0 ? void 0 : maybeSlot.time);
    (0,react.useEffect)(()=>{
        dispatch(store/* actions.setConfig */.Nw.setConfig({
            pageLoaded: true
        }));
    }, [
        dispatch
    ]);
    const bookingBtnHandler = ()=>{
        (0,Carbon/* trackToPatient */.Zr)({
            ga: {
                label: "COVID POSITIVE"
            }
        });
    };
    const bookingUrl = (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
        apptReasonId: apptReasons/* ApptReasonId.COVID_I_TESTED_POSITIVE */.xT.COVID_I_TESTED_POSITIVE,
        virtual: true,
        specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE
    });
    const coveredStates = [
        "AL",
        "AZ",
        "CA",
        "CO",
        "FL",
        "GA",
        "IL",
        "MA",
        "MI",
        "MD",
        "NJ",
        "NY",
        "NC",
        "NV",
        "OH",
        "OR",
        "PA",
        "TX",
        "VT",
        "VA",
        "WA",
        "DC"
    ];
    const coverageMapProps = {
        coveredStates
    };
    const faq = (0,useFaqIndex/* useFaqIndex */.l)([
        "How much does it cost to enroll in COVID Positive Care?",
        "Why is Carbon Health offering this program?",
        "What happens if a patient develops COVID-related complications while in the program?",
        "Will Carbon Health be providing repeat testing for patients enrolled in the program?",
        "How are mental health referrals handled?"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("Tested positive for COVID-19? Here's what's next | Carbon Health"),
        pageImage: "covid-positive-enrollment",
        pageDescription: i18n.t("Having tested positive for coronavirus can be scary. Carbon Health is here to help you figure out next steps while making sure you get the care you need."),
        navTheme: useNavState/* NavTheme.LIGHT */.Xm.LIGHT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidPositiveCare_Hero, {
                bookingBtnHandler,
                bookingUrl,
                nextApptSlot
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidPositiveCare_About, {
                nextApptSlot,
                bookingUrl,
                bookingBtnHandler
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidPositiveCare_Features, {
                nextApptSlot,
                bookingUrl,
                bookingBtnHandler
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v5_CoverageMap, {
                ...coverageMapProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidPositiveCare_QuestionAnswers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CovidPositiveCare_Resources, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                faq: faq
            })
        ]
    });
};
/* harmony default export */ var covid_positive_care = (CovidPositiveEnrollment);


/***/ }),

/***/ 99274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outer":"CoverageMap_outer__OMazO","inner":"CoverageMap_inner__eKcZg","header":"CoverageMap_header__ZtjU_","list":"CoverageMap_list__BuX1g","map":"CoverageMap_map__ieg8P","state":"CoverageMap_state__AdRVo","not-covered":"CoverageMap_not-covered__uOxkd","state-name":"CoverageMap_state-name__3woQ_","state-code":"CoverageMap_state-code__U6dv_"};

/***/ }),

/***/ 53423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outer":"Resources_outer__R4X2r","inner":"Resources_inner__REdjd","header":"Resources_header__2C1UO","title":"Resources_title__43z0k","text":"Resources_text__C5l_B"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,2493,6282,2122,620,9774,2888,179], function() { return __webpack_exec__(38993); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);